"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class RecurringTaskRunner {
    constructor(task, intervalMs, waitBeforeFirstRun) {
        this.timeoutId = null;
        this.cancel = null;
        this.stopped = false;
        this.start = () => {
            if (this.stopped) {
                return;
            }
            const runInLoop = () => {
                if (this.stopped)
                    return;
                this.timeoutId = setTimeout(_ => this.task().finally(runInLoop), this.intervalMs);
            };
            if (this.waitBeforeFirstRun) {
                runInLoop();
            }
            else {
                this.task().finally(runInLoop);
            }
        };
        this.stop = () => {
            this.stopped = true;
            if (this.timeoutId) {
                clearTimeout(this.timeoutId);
            }
        };
        this.task = task;
        this.intervalMs = intervalMs;
        this.waitBeforeFirstRun = waitBeforeFirstRun;
    }
    static startNew(task, intervalMs, waitBeforeFirstRun) {
        const taskRunner = new RecurringTaskRunner(task, intervalMs, waitBeforeFirstRun);
        taskRunner.start();
        return taskRunner;
    }
}
exports.default = RecurringTaskRunner;
